import { ReactNode } from "react";
import { Link } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./StarworksButton.css";

interface StarworksButtonProps {
  children: ReactNode;
  to?: string;
  dropdown?: { label: string; to: string }[];
}

export const StarworksButton = ({ children, to, dropdown }: StarworksButtonProps) => {
  if (dropdown) {
    return (
      <NavDropdown title={children} id="starworks-dropdown" className="starworks-button-dropdown">
        {dropdown.map((item, index) => (
          <NavDropdown.Item as={Link} to={item.to} key={index}>
            {item.label}
          </NavDropdown.Item>
        ))}
      </NavDropdown>
    );
  }

  return (
    <Link to={to || "#"} className="no-underline">
      <div className="starworks-button">{children}</div>
    </Link>
  );
};
